<template>
  <md-toolbar md-elevation="0" class="md-transparent">
    <md-dialog :md-active.sync="showChangePassDialog">
      <md-dialog-title>Trocar Senha</md-dialog-title>
      <div class="md-layout">
        <div class="md-layout-item md-small-size-100 md-size-100">
          <md-field>
            <label>Senha atual</label>
            <md-input></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-50">
          <md-field>
            <label>Nova senha</label>
            <md-input></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-50">
          <md-field>
            <label>Confirmar nova senha</label>
            <md-input></md-input>
          </md-field>
        </div>
      </div>
      <md-dialog-actions>
        <md-button class="md-primary" @click="showChangePassDialog = false">
          Salvar
        </md-button>
      </md-dialog-actions>
    </md-dialog>
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">{{ $route.name }}</h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <!--
          <div class="md-autocomplete">
            <md-autocomplete
              class="search"
              v-model="selectedEmployee"
              :md-options="employees"
            >
              <label>Search...</label>
            </md-autocomplete>
          </div>
          -->
          <md-list>
            <!--
            <md-list-item href="#/">
              <i class="material-icons">dashboard</i>
              <p class="hidden-lg hidden-md">Dashboard</p>
            </md-list-item>
            -->

            <!-- <md-list-item href="#/notifications" class="dropdown">
              <drop-down>
                <a slot="title" class="dropdown-toggle" data-toggle="dropdown">
                  <i class="material-icons">notifications</i>
                  <span class="notification">5</span>
                  <p class="hidden-lg hidden-md">Notifications</p>
                </a>
                <ul class="dropdown-menu dropdown-menu-right">
                  <li><a href="#">Mike John responded to your email</a></li>
                  <li><a href="#">You have 5 new tasks</a></li>
                  <li><a href="#">You're now friend with Andrew</a></li>
                  <li><a href="#">Another Notification</a></li>
                  <li><a href="#">Another One</a></li>
                </ul>
              </drop-down>
            </md-list-item> -->

            <li class="md-list-item">
              <a
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
              >
                <div class="md-list-item-content">
                  <drop-down>
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon>notifications</md-icon>
                      <span
                        v-if="notifications.length > 0"
                        class="notification"
                      >
                        {{ notifications.length }}
                      </span>
                      <p class="hidden-lg hidden-md">Notifications</p>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li
                        v-for="(notification, i) in notifications"
                        :key="`notification-${i}`"
                      >
                        <router-link :to="notification.link">{{
                          notification.message
                        }}</router-link>
                      </li>
                      <li v-if="notifications.length === 0">
                        <a href="#">Você não possui notificações</a>
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>

            <li class="md-list-item">
              <a
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
              >
                <div class="md-list-item-content">
                  <drop-down>
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <i class="material-icons">person</i>
                      <p class="hidden-lg hidden-md">Perfil</p>
                      <span class="user-name">{{ username }}</span>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <!--
                      <li>
                        <a href="#" @click="showChangePassDialog = true">
                          <i class="material-icons">lock</i> Alterar senha
                        </a>
                      </li>
                      -->
                      <li>
                        <a @click="exit" href="#">
                          <i class="material-icons">logout</i> Sair
                        </a>
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import { mapActions } from "vuex";
import { updateList } from "../../helpers";

export default {
  computed: {
    username() {
      return this.$store.getters.userName.split(" ")[0];
    },
    userid() {
      return this.$store.getters.user.id;
    },
    contracts() {
      return this.$store.getters.contracts;
    },
    unsignedContracts() {
      return this.$store.getters.unsignedContracts;
    },
    points() {
      return this.$store.getters.points;
    },
    notifications() {
      const messages = [];
      if (this.unsignedContracts.length > 0) {
        messages.push({
          link: "/contracts",
          message: `Você possui ${this.unsignedContracts.length} contrato(s) pendente(s)!`
        });
      }

      // const updatable = this.points.filter(p => updateList.has(p.plan_id));
      // if (updatable.length > 0) {
      //   messages.push({
      //     link: "/services",
      //     message: `Você possui ${updatable.length} planos que podem ser atualizados!`
      //   });
      // }

      return messages;
    }
  },
  data() {
    return {
      showChangePassDialog: false
    };
  },
  methods: {
    ...mapActions(["logout", "fetchContracts"]),
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    exit() {
      this.logout();
      this.$router.push("/auth/login");
    }
  },
  async mounted() {
    await this.fetchContracts({ id: this.userid });
  }
};
</script>

<style lang="css">
.user-name {
  font-size: 15px;
}

ul li a i {
  font-size: 18px !important;
}
</style>
